module.exports = __webpack_public_path__ + "static/eliya-complete-23cbcdafab3924129455de2e126c8db8.jpg";